import React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

type EmptyStateProps = {
  message: string;
};

export const EmptyState = ({ message }: EmptyStateProps) => {
  return (
    <Grid container justifyContent="center" py={4}>
      <Typography variant="body1" color="text.secondary">
        {message}
      </Typography>
    </Grid>
  );
};
